import { ICardElementWithChildren } from "backend/model/model";
import ValueInputForm from "design/components/forms/ValueInputForm";
import React from "react";
import * as types from "@qpr/client-api-workflow/types";
import { t } from "i18next";
import { TSubmitValues } from "backend/datainput";
import useAttachments from "backend/hooks/files/useAttachments";
import Loader from "@qpr/client-api-base/ui/components/Loader";

const InitiativeApproveForm = (props: {
  selectedRow: ICardElementWithChildren;
  comments?: types.WFComment[];
  onSubmit?: (value: TSubmitValues) => void;
  canReject?: boolean;
  canApprove?: boolean;
}) => {
  const { selectedRow, comments, canReject, canApprove } = props;
  const { data: attachments, isLoading: isLoadingAttachments } = useAttachments(
    { elementId: selectedRow.id, period: selectedRow.workflowInstance?.period }
  );
  if (isLoadingAttachments) return <Loader />;
  return (
    <ValueInputForm
      key={selectedRow?.workflowInstance?.wfInstanceId}
      element={selectedRow!}
      fields={[
        {
          title: t("workflowinput.form.Attachments"),
          element: selectedRow,
          inputType: "attachments",
          initialFiles: attachments,
          isDisabled: false,
        },
        {
          title: t("workflowinput.form.Actions and Recommendations"),
          element: selectedRow,
          inputType: "comment",
          isDisabled: false,
          comments: comments,
          initialValue: comments && comments[0] ? comments[0].description : "",
        },
        {
          title: t("workflowinput.form.Approval or Rejection message"),
          series: "MESSAGE" as any,
          initialValue: "",
          fullWidth: true,
          element: selectedRow,
          inputType: "string",
          validate: (value) => {
            if (!value.field.value) {
              return {
                success: false,
                errorMessages: [
                  t(
                    "workflowinput.form.errors.Approval or Rejection Message must be Given"
                  ),
                ],
              };
            }
            return {
              success: true,
            };
          },
        },
      ]}
      buttons={[
        {
          tag: "reject",
          style: "reject",
          text: t("workflowinput.form.Reject"),
          isDisabled: !canReject,
          onClick: (fields) => {
            console.log("Might send for reject ", fields);

            if (props.onSubmit) {
              props.onSubmit({
                fields: fields,
                message: fields
                  .filter((v) => v.series === "MESSAGE")
                  .map((f) => f.value)
                  .join(""),
                transition: "REJECT",
              });
            }
          },
        },
        {
          tag: "approve",
          style: "approve",
          text: t("workflowinput.form.Approve"),
          isDisabled: !canApprove,
          onClick: (fields) => {
            console.log("Might send for approve", fields);
            if (props.onSubmit) {
              props.onSubmit({
                fields: fields,
                message: fields
                  .filter((v) => v.series === "MESSAGE")
                  .map((f) => f.value)
                  .join(""),
                transition: "APPROVE",
              });
            }
          },
        },
      ]}
    />
  );
};

export default InitiativeApproveForm;
